module.exports = __webpack_public_path__ + "media/images/speaker_guy-f7a1881a75b0ce8c33450b2ecf7d8096.svg";